const Footer=()=>{
    return(
        <footer id="footer">
        <div class="footerContainer"  >
            <div>
            <a class="icon" href="mailto: traviszheng544@gmail.com">
            <i class="far fa-envelope" ></i>
            </a>
            </div>
            <div>
            <a  class="icon" target="_blank" href="https://github.com/Travis544">
            <i class="fab fa-github"></i>
            </a>
            </div>
            <div >
                <a class="icon" id="reference" target="_blank" href="https://travis544.github.io/">Personal Site</a>
            </div>
        </div>
        Coded by Travis Zheng in 2021.
    </footer>
  
    )

}

export default Footer